import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import './perfex-documents.css';
import './perfex-report-hermes.css';
import './brief-cockpit.css';
import './briefs-workspace.css';
import './proposal-client.css';
import './app-state.css';
import './appointment-analytics.css';
import './appointments-platform.css';
import './public-booking.css';
import './report-editor.css';
import './eligibility-reports-workspace.css';
import './journey.css';
import './outreach-resources.css';
import './outreach-campaigns.css';
import './agent-control.css';
import { currentPath, migrateLegacyHashUrl } from './navigation';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root missing in index.html');

migrateLegacyHashUrl();
const publicDocument = /^\/public\/(reports|proposals)\/[0-9a-f-]+$/i.test(currentPath());
const bookingMatch = window.location.pathname.match(/^\/(?:([a-z]{2}(?:-[A-Z]{2})?)\/)?book\/([a-z0-9-]+)\/?$/i);
const App = lazy(() => import('./App').then((module) => ({ default: module.App })));
const PublicDocumentApp = lazy(() => import('./document-design').then((module) => ({ default: module.PublicDocumentApp })));
const PublicBookingApp = lazy(() => import('./public-booking').then((module) => ({ default: module.PublicBookingApp })));

createRoot(rootEl).render(
  <StrictMode>
    <Suspense fallback={<main className="application-boot" aria-label="Chargement"><i/><i/><i/></main>}>
      {bookingMatch ? (
        <PublicBookingApp locale={bookingMatch[1] || 'fr-CH'} slug={bookingMatch[2]!} />
      ) : publicDocument ? <PublicDocumentApp /> : <App />}
    </Suspense>
  </StrictMode>,
);
